<!--  -->
<template>
  <div>
    <!-- <el-form ref="formData" label-width="96px" :model="formData" :rules="rules"> -->
    <el-form label-width="96px" :model="formData">
      <!-- <el-form-item label="小程序名称" prop="name"> -->
      <el-form-item label="小程序名称" prop="name">
        <el-input v-model.trim="formData.name" style="width: 300px;" />
      </el-form-item>
      <!-- <el-form-item label="APPID" prop="appid"> -->
      <el-form-item label="APPID" prop="appid">
        <el-input v-model.trim="formData.appid" style="width: 300px;" />
      </el-form-item>
      <el-form-item label="ghid" prop="gh_id">
        <el-input v-model.trim="formData.gh_id" style="width: 300px;" />
      </el-form-item>
      <el-form-item>
        <!-- <el-button type="primary" @click="submitForm('formData')">提交</el-button> -->
        <el-button type="primary" @click="submitForm">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { updateProgram } from '@/api/templatelist.js'
export default {
  components: { },
  data() {
    return {
      formData: {
        name: '',
        appid: '',
        gh_id: ''
      },
      // rules: {
      //   name: [{ max: 20, message: '长度不能超过20个字符', trigger: 'blur' }]
      // },
      id: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(row) {
      console.log('edit row---', row)
      this.formData.name = row.name
      this.formData.appid = row.app_id
      this.formData.gh_id = row.gh_id
      this.id = row.id
    },
    async submitForm(formName) {
      if (this.formData.name === '') {
        this.$message.error('请输入小程序名称')
        return
      }
      if (this.formData.appid === '') {
        this.$message.error('请输入APPID')
        return
      }
      if (this.formData.gh_id === '') {
        this.$message.error('请输入ghid')
        return
      }
      const data = await updateProgram({ name: this.formData.name, app_id: this.formData.appid, id: this.id, gh_id: this.formData.gh_id })
      console.log('data----add', data)
      if (data.code === 200) {
        this.$message.success('修改成功')
        this.$emit('editprogram')
      }
      // this.$refs[formName].validate(async(valid) => {
      //   if (valid) {
      //     const data = await updateProgram({ name: this.formData.name, app_id: this.formData.appid, id: this.id })
      //     console.log('data----add', data)
      //     if (data.code === 200) {
      //       this.$message.success('修改成功')
      //       this.$emit('editprogram')
      //     }
      //   } else {
      //     console.log('error submit!!')
      //     return false
      //   }
      // })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
